import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrganizationState {
  selectedOrganizationId: number | null;
  setSelectedOrganizationId: (id: number | null) => void;
}

export const useOrganizationStore = create<OrganizationState>()(
  persist(
    (set) => ({
      selectedOrganizationId: null,
      setSelectedOrganizationId: (id) => set({ selectedOrganizationId: id }),
    }),
    {
      name: "organization-store",
    }
  )
);
